import React from 'react';

import Field, { hasDataInFields } from '../../Field';
import SectionContainer from '../SectionContainer';

import css from './SectionSellWithVena.module.css';

const SectionSellWithVena = props => {
  const {
    sectionId,
    className,
    title,
    description,
    appearance,
    callToAction,
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields(
    [title, description, callToAction],
    fieldOptions
  );

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={css.root}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={css.sectionDetails}>

          <Field
            data={title}
            className={css.title}
            options={fieldOptions}
          />

          <Field
            data={description}
            className={css.description}
            options={fieldOptions}
          />

          <Field
            data={callToAction}
            className={css.ctaButton}
            options={fieldOptions}
          />
        </header>
      ) : null}
    </SectionContainer>
  );
};

export default SectionSellWithVena;